import { createSlice } from "@reduxjs/toolkit";
import { GetAllDietPlanServices, GetMealPlanServices, GetAllDietPlanByUser, addActivity, updateRecipeServices } from "./thunk";


const dietPlanSlice = createSlice({
    name: 'dietPlan',
    initialState: {
        dietPlans: [],
        mealPlans: [],
        data: [],
        dailyGoal : {},
        user: [],
        loading: false,
        error: null
    },

    extraReducers: (builder) => {
        builder
          .addCase(GetAllDietPlanServices.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(GetAllDietPlanServices.fulfilled, (state, action) => {
            state.loading = false;
            state.dietPlans = action.payload; // Remplacez les dietPlan par les données de la requête
            console.log('action.payload', action.payload);
          })
          .addCase(GetAllDietPlanServices.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'Erreur inconnue';
          })


          
          .addCase(GetMealPlanServices.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(GetMealPlanServices.fulfilled, (state, action) => {
            state.loading = false;
            state.mealPlans = action.payload.data; // Remplacez les dietPlan par les données de la requête
            console.log('action.payload', action.payload.data);
            console.log('action.pa', state.mealPlans);
          })
          .addCase(GetMealPlanServices.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'Erreur inconnue';
          })


          .addCase(GetAllDietPlanByUser.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(GetAllDietPlanByUser.fulfilled, (state, action) => {
            state.loading = false;
            state.mealPlans = action.payload.data; // Remplacez les dietPlan par les données de la requête
            console.log('action.payload', action.payload.data);
            console.log('action.pa', state.mealPlans);
          })
          .addCase(GetAllDietPlanByUser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'Erreur inconnue';
          })

          .addCase(addActivity.pending, (state) => {
            //state.loading = true;
            state.error = null;
          })
          .addCase(addActivity.fulfilled, (state, action) => {
            state.loading = false;
           // state.user = action.payload.user// Ajoute l'activité dans le store
          })
          .addCase(addActivity.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          .addCase(updateRecipeServices.pending, (state) => {
            state.isLoading = true;
            state.error = null;
          })
          .addCase(updateRecipeServices.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
          })
          .addCase(updateRecipeServices.rejected, (state, action) => {
            state.isLoading = false;
            // action.payload contient déjà le message du backend
            state.error = action.payload;
          });
          
         
      },
    });
    
    export default dietPlanSlice.reducer;